import { createSelector } from 'reselect';

import getRemainingTotal from './getRemainingTotal';

export default createSelector([getRemainingTotal], remainingTotal => {
  return !(remainingTotal > 0);
});
